<template>
  <div class="w-100">
		<div class="w-100 text-center py-3 mb-4 radius-8" style="background-color: #ffe7d4 !important;">
			<p class="body-2-1 mb-1">Payment expired in</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div class="p-3 radius-8 border-semi-grey mb-4 text-left">
			<div class="w-100 mb-3">
				<p class="mb-0 body-2-2-1">Guest Name</p>
				<p class="mb-0 body-2-1">{{ `${customer_detail.first_name} ${$isNotEmpty(customer_detail.last_name)?customer_detail.last_name:''}` }}</p>
			</div>
			<div class="w-100 mb-3">
				<p class="mb-0 body-2-2-1">Email</p>
				<p class="mb-0 body-2-1">{{customer_detail.email}}</p>
			</div>
			<div class="w-100 mb-3 pb-3 border-b-semi-grey-dashed">
				<p class="mb-0 body-2-2-1">Phone Number</p>
				<p class="mb-0 body-2-1">{{$isNotEmpty(customer_detail.phone_number) ? customer_detail.phone_number : ''}}</p>
			</div>
			<div class="row no-gutters">
				<div class="col-6 align-self-center">
					<p class="mb-0 body-1-4">Total Payment</p>
				</div>
				<div class="col-6 align-self-center text-right">
					<p class="mb-0 body-1-4 text-green">{{$formatCurrency(payment.total_bill)}}</p>
				</div>
			</div>
		</div>
		<div class="p-3 radius-8 border-semi-grey mb-4">
			<div class="row no-gutters">
        <div class="col-12 mt-4 text-center">
					<p class="mb-0 body-1-4">{{getMerchant.name}}</p>
				</div>
				<div class="col-8 offset-2 text-center">
					<img :src="payment.qr_code" class="w-100">
				</div>
				<div class="col-12 my-3">
					<div class="w-100 border-b-semi-grey-dashed">
					</div>
				</div>
				<div class="col-6 align-self-center text-left">
					<p class="mb-0 body-1-4">Total Payment</p>
				</div>
				<div class="col-6 align-self-center text-right">
					<p class="mb-0 body-1-4 text-green">{{$formatCurrency(payment.total_bill)}}</p>
				</div>
        <div class="col-12 text-center mt-4">
          <button class="g-btn g-btn-lg g-btn g-btn-primary w-100" @click="$openLink(payment.url_redirect)">Click here to open your E-Wallet</button>
        </div>
        
        
				<!-- <div class="col-9" :class="payment.pm_image != null ? 'col-9' : 'col-12'">
					<div class="pr-3">
						<p class="mb-0 body-2-2-1">Payment Method</p>
						<p class="mb-0 body-1-4">{{payment.pm_name}}</p>
					</div>
				</div>
				<div class="col-3">
					<img :src="payment.pm_image" style="width: 100%; object-fit:contain;">
          <button class="g-btn g-btn-lg g-btn g-btn-primary w-100" @click="$openLink(payment.payment_gateway_page,'_blank')">Click here to payment</button>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
  import moment from 'moment'
  import {mapGetters} from 'vuex'

  export default {
    props:{
			data:{
				type: Object
			},
			customer_detail:{
				type: Object,
				default: () => {}
			}
		},
		data(){
			return{
				countdown: moment(),
	      timeout: false,
	      payment: {}
			}
		},
    computed:{
			...mapGetters(['getMerchant'])
		},
    mounted(){
			this.setupData().then(()=>{
				this.setupCountdown()
			})
		},
    methods:{
      setupCountdown(){
				let now = moment().format("YYYY-MM-DD HH:mm:ss")
				let exp = moment(this.payment.expired_date_utc).format("YYYY-MM-DD HH:mm:ss")
	      this.countdown = moment.duration(moment(exp).diff(moment(now)))

	      let looping = setInterval(() => {
          this.countdown = this.countdown.subtract(1, 'seconds')
	        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
	          clearInterval(looping)
	          this.timeout = true
	        }
	      },1000)
			},
      setupData(){
        return new Promise((resolve, reject) => {
          this.payment = {
            pg_company: this.data.payment_details.bank_name,
            pm_name: this.data.payment_details.payment_method_name,
            pm_description: this.data.payment_details.payment_channel_description,
            url_redirect: this.data.payment_details.url_redirect,
            qr_code: `data:image/png;base64,${this.data.payment_details.qr_code}`,
            expired_date_utc: this.data.payment_details.expired_date_utc,
            total_bill: Number(this.data.payments.payment_surcharge) > 0 ? Number(this.data.payments.total_deposit) + Number(this.data.payments.payment_surcharge) : Number(this.data.payments.total_deposit)
          }
          resolve()
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/payment/EWallet.vue